import script from "./EstoqueMovimentacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./EstoqueMovimentacoes.vue?vue&type=script&setup=true&lang=js"

import "./EstoqueMovimentacoes.vue?vue&type=style&index=0&id=5e75e83b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e75e83b"]])

export default __exports__